"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensesPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
const LicenseCard_1 = __importDefault(require("../LicenseCard"));
function LicensesPanel({ licenses }) {
    const { isMobile, isWindows } = (0, device_1.usePlatform)();
    const hasOffer = licenses.some(license => { var _a; return !!((_a = license.product) === null || _a === void 0 ? void 0 : _a.offer); });
    const renderButtons = () => {
        return licenses.map(license => {
            return (0, jsx_runtime_1.jsx)(LicenseCard_1.default, { license: license, "data-e2e": 'LicensesPanel_LicenseCard' }, license.type);
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isMobile ? ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'LicensesPanel_Container', children: renderButtons() })) : ((0, jsx_runtime_1.jsx)(ContainerDesktop, { "data-e2e": 'LicensesPanel_ContainerDesktop', children: renderButtons() })), hasOffer && ((0, jsx_runtime_1.jsx)(Hint, { "data-e2e": 'LicensesPanel_Hint', children: (0, i18n_1.Localized)(i18n_1.Strings.store.trial[isWindows ? 'returnHintWindows' : 'returnHint']) }))] }));
}
exports.LicensesPanel = LicensesPanel;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;

  width: 100%;
  min-height: 310px;

  margin: 0 auto 20px auto;
  padding: 0;
`;
const ContainerDesktop = (0, styled_components_1.default)(Container) `
  flex-direction: row;
`;
const Hint = styled_components_1.default.div `
  margin: 20px auto;
  font-size: 12px;
  text-align: center;
`;
